//* 组件库
import type { UiTooltip } from "various-ui";
//* 公共函数
import { copyText } from "@/assets/js/system";
//* 组件属性
import type { DefaultShareProps } from "../index";

export const useComposable = (define: DefaultShareProps) => {
    //* 获取Vue信息
    const route = useRoute();
    const config = useRuntimeConfig();

    //* 节点
    const nodes = {
        tooltip: ref<InstanceType<typeof UiTooltip>>(),
    };

    //* 函数列表
    const methods = {
        //* 复制链接
        copy: () => copyText(computeds.link.value),
        //* 分享Weibo
        weibo: () => {
            open(
                `https://service.weibo.com/share/share.php?url=${computeds.link.value}&title=${define.origin?.title}`,
                "",
                "top=120,left=120,width=480,height=680"
            );
        },
        //* 分享Facebook
        facebook: () => {
            open(`https://www.facebook.com/sharer/sharer.php?u=${computeds.link.value}`, "", "top=120,left=120,width=480,height=680");
        },
        //* 分享Twitter
        twitter: () => {
            open(`https://www.twitter.com/intent/tweet?&text=RDDC&url=${computeds.link.value}`, "", "top=120,left=120,width=480,height=680");
        },
    };

    //* 计算属性
    const computeds = {
        link: computed(() => {
            return config.public.SHARE_DOMAIN + route.fullPath;
        }),
    };

    return { nodes, methods };
};
